module.exports = __webpack_public_path__ + "static/img/company-11.4b5e771a.png";